import { render, staticRenderFns } from "./WaterSupply.vue?vue&type=template&id=39f8a968&scoped=true&"
import script from "./WaterSupply.vue?vue&type=script&lang=js&"
export * from "./WaterSupply.vue?vue&type=script&lang=js&"
import style0 from "./WaterSupply.vue?vue&type=style&index=0&id=39f8a968&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f8a968",
  null
  
)

export default component.exports